import { useEffect } from "react"

import { Outlet, useNavigate,useLocation } from "react-router-dom"
import FooterComponent from "../components/footer/footer";
import HeaderComponent from "../components/header";
import SidebarComponent from "../components/sidebar/sidebar";
import { consoleLog } from "../services/common/utils";
import { useSelector } from "react-redux";


const HomeRoute = ({isNojoomHome}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const customerprofile = useSelector(
        (state) => state?.userdata?.value?.customerprofile || {}
      );
      const isWifiCase = useSelector(
        (state) => state?.userdata?.value?.isWifiCase
      );
      const {
        utilityData: { showNotificationAndProfile }
    } = useSelector((state) => state);
consoleLog("==Home route==");


useEffect(() => {
    const handleScroll = event => {
    //   alert("scrolled")
    var limit = 300;  
    var st = window.scrollY;
        const ele = document.getElementById('transistion');
        if(ele){
            if(st<=limit) {
                var _range = (1-(st/limit));
                if(_range < 0.22){
                 ele.style.opacity = "0.0000000";//"0.0493826";
                 ele.style.display = "none";
                }else{
                    ele.style.opacity = (1-(st/limit))
                    ele.style.display = ""
                }
                //ele.style.opacity = (1-(st/limit))
            }else{
                ele.style.opacity = "0.0000000";//"0.0493826";
                ele.style.display = "none"
            }
        }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


    return (
        <div id={isNojoomHome ? 'container_main' : ''} className='body_container post_login'>     
        {
            (location.pathname == "/home/index" || location.pathname == "/home") ? <></>:
            <HeaderComponent type={isNojoomHome ? '2A' : 2} 
             icon = {isWifiCase}></HeaderComponent>
        }      
            {/* need to apply below classes if homepage and video theme */}
            {/* sp16-main-video-banner sp16-page-bounce-effect */}
          
            <SidebarComponent></SidebarComponent>
            <section id={isNojoomHome ? 'content_cont' : 'content_cont'} className={`app_main_wrapper pt-0 d-flex flex-column position-relative ${isNojoomHome ? '' : `pb-76 ${showNotificationAndProfile ? '' : 'sp16-main-video-banner'} sp16-page-bounce-effect`} `}
                // style={{background: location?.pathname === "/home/index" || location?.pathname === "/home" ? "#F9F9F9": "",
                // overflow: location?.pathname === "/home/index" || location?.pathname === "/home" ? "auto" : ""
            // }}
            >
                <div className="center_section scroll-pg-cont">
                    <div className="sec_top">
                        <Outlet />
                    </div>
                </div>
            </section>
            <FooterComponent></FooterComponent>
        </div>
    )
}
export default HomeRoute